import jQuery from "jquery";
import jrespond from "jrespond";

const jres = jrespond([
	{
		label: "handheldportrait",
		enter: 0,
		exit: 400,
	},
	{
		label: "handheldlandscape",
		enter: 401,
		exit: 767,
	},
	{
		label: "iPad-portrait",
		enter: 768,
		exit: 768,
	},
	{
		label: "iPad-landscape",
		enter: 1024,
		exit: 1024,
	},
	{
		label: "tablet",
		enter: 769,
		exit: 979,
	},
	{
		label: "laptop",
		enter: 980,
		exit: 1439,
	},
	{
		label: "desktop",
		enter: 1440,
		exit: 10_000,
	},
]);

/**
 *
 * Singleton used to register the responsive breakpoints,
 * and to plug hooks to these breakpoints.
 *
 */
function responsive() {
	const that = {};

	/**
	 * Register hook functions to a collection of breakpoints.
	 *
	 * @param {{}} hook
	 * @param {string[]} hook.breakpoints - labels for breakpoints
	 * @param {function} hook.enterCallback - callback performed when a breakpoint is entered
	 * @param {function} hook.exitCallback - callback performed when a breakpoint is exited
	 *
	 *  Note that the enter and exit functions are the same for all the
	 *  breakpoints registered.
	 * @example
	 *	responsive.registerToBreakpoints({
	 *		breakpoints: ['handheldportrait', 'handheldlandscape'],
	 *		enterCallback: showTabs,
	 *		exitCallback: hideTabs
	 *	});
	 */

	that.registerToBreakpoints = function (hook) {
		const breakpoints = hook.breakpoints || [];

		breakpoints.forEach((breakpoint) => {
			registerToBreakpoint({
				breakpoint,
				enter: hook.enterCallback || function () {},
				exit: hook.exitCallback || function () {},
			});
		});
	};

	that.registerToMobileBreakpoint = function (options) {
		options.breakpoints = ["handheldportrait", "handheldlandscape"];
		that.registerToBreakpoints(options);
	};

	/**
	 * Check if the current breakpoint is corresponding to the breakpoint provided as argument.
	 *
	 * @param {string} breakpointLabel - label corresponding to a registered breakpoint
	 * @return {boolean} true if the current breakpoint matches, false otherwise
	 */
	that.isCurrentBreakpoint = function (breakpointLabel) {
		return jres.getBreakpoint() === breakpointLabel;
	};

	/**
	 * Check if the current breakpoint is corresponding to mobile (portrait or landscape).
	 *
	 * @return {boolean}
	 */
	that.isMobileBreakpoint = function () {
		return (
			that.isCurrentBreakpoint("handheldportrait") ||
			that.isCurrentBreakpoint("handheldlandscape")
		);
	};

	/**
	 * Check if the current breakpoint is corresponding to mobile (portrait or landscape) or to iPad (portait).
	 *
	 * @return {boolean}
	 */
	that.isMobileOrIPadPortaitBreakpoint = function () {
		return (
			that.isMobileBreakpoint() ||
			that.isCurrentBreakpoint("iPad-portrait")
		);
	};

	/**
	 * Check if the current breakpoint is corresponding to iPad (portrait or landscape).
	 *
	 * @return {boolean}
	 */
	that.isIPadBreakpoint = function () {
		return (
			that.isCurrentBreakpoint("iPad-portrait") ||
			that.isCurrentBreakpoint("iPad-landscape")
		);
	};

	/**
	 * Check if the current device support touch events.
	 *
	 * @return {boolean}
	 */
	that.isTouchDevice = function () {
		return "ontouchstart" in document.documentElement;
	};

	/**
	 * Return weither the app is in fullscreen mode
	 */
	that.isStandalone = function () {
		if ("standalone" in window.navigator) {
			return window.navigator.standalone;
		}
		return false;
	};

	/**
	 * Replaces all anchor href clicks with a `window.location`
	 * call instead. This is needed for IOS in standalone mode,
	 * else all links will result in opening the link in a tab in
	 * Safari.
	 */
	that.setupStandaloneMode = function () {
		jQuery("body").on("click", "a", function (event) {
			const href = jQuery(this).attr("href");
			const target = jQuery(this).attr("target");

			// For external link, do nothing (they will be opened
			// in Safari).
			if (href && target !== "_blank") {
				window.location = href;
				event.preventDefault();
			}
		});
	};

	/**
	 * Register a function to call on orientation changes.
	 * This only happen on handheld devices.
	 *
	 * @param {function} callback - Function to call when the orientation changes
	 */
	that.onOrientationChange = function (callback) {
		jQuery(window).on("orientationchange", callback);
	};

	/**
	 * Internal function used to bridge breakpoints registration.
	 *
	 * @param {object} options - Breakpoint definition
	 */
	function registerToBreakpoint(options) {
		jres.addFunc(options);
	}

	return that;
}

export default responsive();
